import React from 'react';

export const tableCols = [
  {
    headerName: 'ID',
    field: 'dbId',
    width: 50,
  },
  {
    headerName: 'Name',
    field: 'name',
    flex: 1,
    filter: true,
  },
  {
    headerName: 'Stage',
    field: 'stgName',
    width: 100,
    filter: true,
  },
  {
    headerName: 'Definition',
    field: 'definition',
    flex: 1,
    filter: true,
  },
  {
    headerName: 'Guidance',
    field: 'guidance',
    flex: 1,
    filter: true,
  },
  {
    headerName: 'Benchmark Type',
    field: 'benchmarkType',
    flex: 1,
    filter: true,
  },
  {
    headerName: 'Measurement',
    field: 'measurementType.name',
    flex: 1,
    filter: true,
  },
  {
    headerName: 'Tags',
    field: 'tags',
    flex: 1,
    valueGetter: ({ value }) => value?.map(({ tag }) => tag)?.join(', '),
    tooltipValueGetter: ({ data }) =>
      data?.tags?.map(({ tag }, index) => <p key={`${tag}-${index}`}>{tag}</p>),
  },
  {
    headerName: 'Impact Models',
    field: 'services',
    flex: 1,
    valueGetter: ({ value }) => value?.map(({ name }) => name)?.join(', '),
    tooltipValueGetter: ({ data }) => (
      <>
        {data?.services?.map(({ name }, index) => (
          <p key={`${name}-${index}`}>{name}</p>
        ))}
      </>
    ),
  },
];
